import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISerie, ISerieDetail } from "src/models/General/Serie.models";

interface seriestate {
  series: ISerie[];
  serieToEdit: ISerie | null;
}

const initialState: seriestate = {
  series: [],
  serieToEdit: null,
};

const serieSlice = createSlice({
  name: "Serie",
  initialState,
  reducers: {
    setSerieList: (state, action: PayloadAction<ISerie[]>) => {
      state.series = action.payload;
    },
    concatListSerie: (state: seriestate, action: PayloadAction<ISerie[]>) => {
      state.series = [...state.series.concat(action.payload)];
    },
    setSerieToEdit: (state, action: PayloadAction<ISerie | null>) => {
      state.serieToEdit = action.payload;
    },
    setDetailsToSerieToEdit: (state, action: PayloadAction<ISerieDetail[]>) => {
      if (state.serieToEdit) {
        if (!state.serieToEdit.details) {
          state.serieToEdit.details = [];
        }
        state.serieToEdit.details = action.payload;
      }
    },
    addSerie: (state, action: PayloadAction<ISerie>) => {
      state.series.push(action.payload);
    },
    updateSerie: (state, action: PayloadAction<ISerie>) => {
      let itemIndex = state.series.findIndex(
        item => item.serieId === action.payload.serieId
      );
      if (itemIndex !== -1) state.series[itemIndex] = action.payload;
    },
    deleteSerie: (state, action: PayloadAction<number>) => {
      const newArray = state.series.filter(
        item => item.serieId !== action.payload
      );
      state.series = newArray;
    },
  },
});

export const {
  setSerieList,
  concatListSerie,
  setSerieToEdit,
  setDetailsToSerieToEdit,
  addSerie,
  updateSerie,
  deleteSerie,
} = serieSlice.actions;

export default serieSlice.reducer;
